module.exports = __webpack_public_path__ + "img/BannerNewMobile.ad2ecc2a.png";